import React from 'react';
import PropTypes from 'prop-types';

function DocumentPhotoIcon({ className = '', width = 24, height = 24, strokeWidth = 1.75, ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      {...props}
    >
      <rect x='3' y='4' width='18' height='14' rx='2' />
      <line x1='3' y1='10' x2='21' y2='10' />
    </svg>
  );
}

DocumentPhotoIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DocumentPhotoIcon;
